import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { PlayerEvent } from '../../../../../services/interfaces';
import type { MatchHeaderStoreState } from '../../../../../services/interfaces/match-header';
import { translateEntity } from '../../../../../services/utils';
import { getPlayerServiceUrl } from '../../../match-unit/helpers';

type Props = {
  state: ObservableMap<MatchHeaderStoreState>['state'];
};

const renderPenalty = (penalty: PlayerEvent) => {
  return (
    <li>
      <span class="pk-match-header__missed-penalties--player-name">{translateEntity(penalty.player).shortName}</span>{' '}
      <span class="pk-match-header__missed-penalties--minutes">{penalty.time.minute}'</span>
    </li>
  );
};

const renderPenaltyWithLink = (penalty: PlayerEvent, competitionId: string, playerServiceUrl: string) => {
  return (
    <li>
      <a
        class="pk-match-header__missed-penalties--player-link"
        href={getPlayerServiceUrl(playerServiceUrl, penalty.player.id, competitionId)}
      >
        <span class="pk-match-header__missed-penalties--player-name">{translateEntity(penalty.player).shortName}</span>{' '}
        <span class="pk-match-header__missed-penalties--minutes">{penalty.time.minute}'</span>
      </a>
    </li>
  );
};

const MatchMissedPenalties = ({ state }: Props) => {
  const match = state.matchData;
  if (!match) return null;

  const disableLink: boolean = state.disablePlayerLink;
  const playerServiceUrl: string = state.playerServiceUrl;

  const awayTeam = match.awayTeam;
  const homeTeam = match.homeTeam;
  const penaltiesMissed = match.playerEvents?.penaltiesMissed;

  if (!penaltiesMissed?.length) return null;

  const awayMissedPenalties = penaltiesMissed.filter((pen) => pen.teamId === awayTeam.id);
  const homeMissedPenalties = penaltiesMissed.filter((pen) => pen.teamId === homeTeam.id);

  return (
    <div class="pk-match-header__missed-penalties">
      <div class="pk-match-header__missed-penalties--home" part="home-missed-penalties">
        <ul class="pk-match-header__missed-penalties--list">
          {homeMissedPenalties.map((pen) => {
            if (!disableLink) return renderPenaltyWithLink(pen, match.competition.id, playerServiceUrl);
            return renderPenalty(pen);
          })}
        </ul>
      </div>
      <pk-icon
        class="pk-match-header__missed-penalties--icon"
        name="football-goal-penalty-missed-color"
        title="penalty missed"
      />
      <div class="pk-match-header__missed-penalties--away" part="away-missed-penalties">
        <ul class="pk-match-header__missed-penalties--list">
          {awayMissedPenalties.map((card) => {
            if (!disableLink) return renderPenaltyWithLink(card, match.competition.id, playerServiceUrl);
            return renderPenalty(card);
          })}
        </ul>
      </div>
    </div>
  );
};

export { MatchMissedPenalties };
